export default __webpack_public_path__ + "8458559111d6f6301859b36e30b20e95.png";